<ion-card class="tm-note" *ngIf="this.tmNote" [class.read]="tmNote?.read">
  <ion-card-content>
    <div>
      <div
        [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-desktop-header'"
        class="tm-header flex-title"
        *ngIf="
          platformService.platformType !== platformService.platformEnum.mobile
        "
      >
        <div [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-desktop-title'">
          <span class="title" (click)="goToDetails()">{{ tmNote.title }}</span>
        </div>
        <div class="flex-title">
          <ion-label
            [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-desktop-date'"
            class="dateRange"
            [ngClass]="!tmNote?.read ? 'unread-dt-bold' : ''"
          >
            {{ tmNote?.updDate | date: 'MM/dd/yyyy' : 'GMT' }} -
            {{ tmNote?.expireDate | date: 'MM/dd/yyyy' : 'GMT' }}
          </ion-label>
          <ion-icon
            [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-desktop-read-icon'"
            *ngIf="!tmNote?.read"
            class="notification-read-icon"
            color="primary"
            name="ellipse"
          ></ion-icon>
        </div>
      </div>

      <div
        [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-mobile-header'"
        class="tm-header"
        *ngIf="
          platformService.platformType === platformService.platformEnum.mobile
        "
      >
        <div class="flex-title">
          <div [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-mobile-title'">
            <span class="title" (click)="goToDetails()">{{
              tmNote.title
            }}</span>
          </div>
          <ion-icon
            [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-mobile-read-icon'"
            *ngIf="!tmNote?.read"
            class="notification-read-icon"
            color="primary"
            name="ellipse"
          ></ion-icon>
        </div>
        <ion-label
          [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-mobile-date'"
          class="dateRange"
          [ngClass]="!tmNote?.read ? 'unread-dt-bold' : ''"
        >
          {{ tmNote?.updDate | date: 'MM/dd/yyyy' : 'GMT' }} -
          {{ tmNote?.expireDate | date: 'MM/dd/yyyy' : 'GMT' }}
        </ion-label>
      </div>

      <div
        class="mb-8"
        *ngIf="
          this.platformService?.platformType !==
          platformService.platformEnum.mobile
        "
      >
        <span
          [attr.data-cy]="
            'tm-note-' + tmNote?.noteId + '-desktop-details-link-span'
          "
          (click)="goToDetails()"
          class="content ion-label-content"
          [innerText]="tmNote?.text"
        ></span>
        <section
          class="ion-content swiper-section"
          *ngIf="
            tmNote?.noteProdNbrs &&
            tmNote?.noteProdNbrs.length > 0 &&
            associatedProducts?.length > 0
          "
        >
          <div id="swiper-slider" class="slider-section">
            <div
              [ngClass]="
                productSwiperRef?.swiper?.isBeginning
                  ? 'swiper-button-disabled'
                  : ''
              "
              class="swiper-button-prev arrow-slider"
              (click)="productSwiperRef?.swiper?.slidePrev()"
            >
              <ion-icon
                slot="icon-only"
                name="arrow-back-circle-outline"
                data-cy="swiper-back-icon"
              >
              </ion-icon>
            </div>
            <swiper-container
              (init)="setSwiperInstance($event.detail[0])"
              no-swiping="false"
              slides-per-view="auto"
              observer="true"
              observe-parents="true"
              resize-observer="true"
              center-insufficient-slides="true"
              #productSwiperRef
            >
              <swiper-slide
                *ngFor="
                  let associatedProduct of associatedProducts
                    | slice: startSlice : endSlice;
                  trackBy: trackItem;
                  let index = index
                "
              >
                <app-product-detail-cab-card
                  [product]="associatedProduct"
                  (quantityUpdateEmitter)="onQuantityUpdate($event, index + 1)"
                  [lnkSrc]="lnkSrc"
                  [isDisable]="associatedProduct?.orderable === false"
                >
                </app-product-detail-cab-card>
              </swiper-slide>
            </swiper-container>

            <div
              [ngClass]="
                productSwiperRef?.swiper?.isEnd ? 'swiper-button-disabled' : ''
              "
              class="swiper-button-next arrow-slider"
              (click)="productSwiperRef?.swiper?.slideNext()"
            >
              <ion-icon
                slot="icon-only"
                name="arrow-forward-circle-outline"
                data-cy="forward-swiper-icon"
              ></ion-icon>
            </div>
          </div>
        </section>

        <div
          class="footer"
          [attr.data-cy]="
            'tm-note-' + tmNote?.noteId + '-desktop-details-link-footer-span'
          "
        >
          <span
            class="ion-label-content view-more-link"
            (click)="goToDetails()"
            translate
          >
            {{
              tmNote?.noteProdNbrs && tmNote?.noteProdNbrs.length > 0
                ? 'i18n.notifications.viewProducts'
                : 'i18n.notifications.ctaLinkLabels.viewDetails'
            }}
          </span>
        </div>
      </div>

      <div
        class="mb-9"
        *ngIf="
          platformService.platformType === platformService.platformEnum.mobile
        "
      >
        <span
          [attr.data-cy]="
            'tm-note-' + tmNote?.noteId + '-mobile-text-details-link-span'
          "
          (click)="goToDetails()"
          class="content ion-label-content"
          [innerText]="tmNote?.text"
        ></span>
        <div
          class="ion-content-mobile"
          *ngIf="tmNote?.noteProdNbrs && tmNote?.noteProdNbrs.length > 0"
        >
          <div
            class="usf-product-card-img"
            *ngFor="
              let thumbnailImageURL of productThumbnails
                | slice: startSlice : 2;
              trackBy: trackItem;
              let index = index
            "
          >
            <img
              [attr.data-cy]="
                'tm-note-' +
                tmNote?.noteId +
                '-mobile-product' +
                index +
                '-image'
              "
              src="{{ thumbnailImageURL?.imageUrl }}"
              (error)="
                thumbnailImageURL[index].imageUrl = getAlternateThumbnail(
                  thumbnailImageURL?.imageUrl
                )
              "
              *ngIf="!!thumbnailImageURL.imageUrl"
              (click)="goToDetails()"
            />
            <ion-icon
              [attr.data-cy]="
                'tm-note-' +
                tmNote?.noteId +
                '-mobile-product' +
                index +
                '-no-image-icon'
              "
              name="restaurant"
              (click)="productClickHandler(thumbnailImageURL.productNumber)"
              *ngIf="!thumbnailImageURL || !thumbnailImageURL?.imageUrl"
              class="no-image"
            ></ion-icon>
          </div>

          <span
            [attr.data-cy]="
              'tm-note-' + tmNote?.noteId + '-mobile-products-details-link-span'
            "
            class="tm-note-span"
            *ngIf="tmNote?.noteProdNbrs?.length > 2"
            (click)="goToDetails()"
          >
            <ion-icon
              name="add"
              class="tm-add-icon"
              [attr.data-cy]="'tm-note-' + tmNote?.noteId + '-mobile-add-icon'"
            ></ion-icon>
            <ion-label
              class="tm-note-other-product"
              [attr.data-cy]="
                'tm-note-' + tmNote?.noteId + '-mobile-show-more-label'
              "
            >
              {{ tmNote?.noteProdNbrs?.length - 2 + ' More' }}
            </ion-label>
          </span>
        </div>

        <div
          class="footer"
          [attr.data-cy]="
            'tm-note-' + tmNote?.noteId + '-mobile-details-link-footer-span'
          "
        >
          <span
            class="ion-label-content view-more-link"
            (click)="goToDetails()"
            translate
          >
            {{
              tmNote?.noteProdNbrs && tmNote?.noteProdNbrs.length > 0
                ? 'i18n.notifications.viewProducts'
                : 'i18n.notifications.ctaLinkLabels.viewDetails'
            }}
          </span>
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
